import {Filtro} from "../models/filtro/filtro";

export const ParticipanteSCH = (perPage) => {
  let filtro = new Filtro();
  filtro.perPage = perPage;
  filtro.fields = ['*'];
   filtro.addOrder('nome','asc')
  return filtro
};
